const weight = {
    lighter: 400,
    normal: 500,
    bold: 600,
}

const ellipsis = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
}

export default {
    ellipsis,
    weight,
}
